import React from 'react';
import { motion } from 'framer-motion';
import { Puzzle, CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  return <section className="py-20 px-4 bg-slate-950" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        {/* La solución */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-14">
          <div className="flex items-center gap-3 mb-8" data-id="element-15">
            <Puzzle className="w-8 h-8 text-teal-400" data-id="element-16" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-17">
              La solución
            </h2>
          </div>
          <p className="text-xl text-slate-300 mb-6" data-id="element-18">
            KIT ORTOPEDISTA PRO fue creado para darte exactamente eso:
          </p>
          <div className="flex flex-wrap gap-4 mb-8" data-id="element-19">
            {['Orden', 'Claridad', 'Precisión', 'Repetibilidad'].map((item, i) => <span key={i} className="bg-teal-950 border border-teal-800 text-teal-300 px-6 py-3 rounded-full font-bold text-lg flex items-center gap-2" data-id="element-20">
                  <CheckCircle2 className="w-5 h-5" data-id="element-21" /> {item}
                </span>)}
          </div>
          <p className="text-xl font-bold text-amber-400 bg-amber-950/20 p-6 rounded-xl border border-amber-900/30" data-id="element-22">
            👉 Es como pasar de manejar sin GPS… a tener una ruta exacta hacia
            la recuperación del paciente.
          </p>
        </motion.div>
      </div>
    </section>;
}